// Remote doesn't depend on react-router-dom: the host app owns the Router,
// so navigation here goes through the raw History API instead of <Link>/useNavigate
// (this is until we migrate our routing mechanism).

export const navigate = (path: string) => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const redirect = (path: string) => {
  window.history.replaceState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const navigateBack = () => {
  window.history.back();
};
